// extracted by mini-css-extract-plugin
module.exports = {"header":"footer-nav-column_header__y1Q98","icon":"footer-nav-column_icon__vLpu1","title":"footer-nav-column_title__zVAnO","list":"footer-nav-column_list__Bg6HQ"};